<script lang="ts">
  import { onMount, untrack } from 'svelte';
  import {
    cancelCapture,
    capturePhoto,
    getShowOverlay,
    startCamera,
    stopCamera,
  } from './index.svelte';
  import IconXmark from '$lib/icons/IconXmark.svelte';
  import Button from '$components/button/Button.svelte';

  let videoElement = $state<HTMLVideoElement | null>(null);

  onMount(() => {
    return () => {
      stopCamera();
      cancelCapture();
    };
  });

  const closeOverlay = () => {
    stopCamera();
    cancelCapture();
  };

  const takePhoto = async () => {
    if (videoElement) {
      await capturePhoto(videoElement);
      closeOverlay();
    }
  };

  $effect(() => {
    if (getShowOverlay() === false || getShowOverlay() === true) {
      untrack(() => {
        if (getShowOverlay() && videoElement) {
          stopCamera();
          startCamera(videoElement);
        }
      });
    }
  });
</script>

{#if getShowOverlay()}
  <div class="fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center bg-black">
    <div class="absolute left-4 top-6 z-10 grid w-full invert pt-safe">
      <Button ariaLabel="Close" variant="secondary" icon onclick={closeOverlay}>
        <IconXmark />
      </Button>
    </div>
    <div class="w-full max-w-lg rounded-lg">
      <video
        bind:this={videoElement}
        autoplay
        playsinline
        class="mb-4 aspect-square w-full object-cover"><track kind="captions" /></video>
    </div>
    <div class="bt-safe absolute bottom-10 left-0 z-10 grid w-full">
      <div
        class="mx-auto block h-16 w-16 rounded-full border-[3px] border-border-subtle bg-background">
        <button
          aria-label="Take photo"
          onclick={takePhoto}
          class="mx-auto block h-full w-full rounded-full border-[2.5px] border-black bg-background"
        ></button>
      </div>
    </div>
  </div>
{/if}
